var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeviceNotEligible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6316 44H12",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3157 47.3159C24.5773 47.3159 24.7894 47.528 24.7894 47.7896V47.7896C24.7894 48.0512 24.5773 48.2633 24.3157 48.2633V48.2633C24.0541 48.2633 23.842 48.0512 23.842 47.7896V47.7896C23.842 47.528 24.0541 47.3159 24.3157 47.3159",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6316 36.4211V47.7895C36.6316 49.8823 34.935 51.5789 32.8421 51.5789H15.7895C13.6966 51.5789 12 49.8823 12 47.7895V11.7895C12 9.6966 13.6966 8 15.7895 8H26.2105",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6316 30.7368C42.9102 30.7368 48 25.647 48 19.3684C48 13.0898 42.9102 8 36.6316 8C30.353 8 25.2632 13.0898 25.2632 19.3684C25.2632 25.647 30.353 30.7368 36.6316 30.7368Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5986 16.0034L32.6052 23.9967",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6011 24.0017L32.6011 16",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeviceNotEligible);
export default __webpack_public_path__ + "static/media/icon-device-not-eligible.cd80a1e1.svg";
export { ForwardRef as ReactComponent };